<div class="m-3">
  <kl-social-form
  (closeDialog)="ok()"
  [profileKey]="profileKey"
  [socialFormDetails]="socialFormDetails">
  </kl-social-form>
</div>
